import { getFormatting } from '../../services/formattingCache';

// Display-only formatting for the Price List page. Prices arrive as exact decimal STRINGS from the
// server and are shown as-is (trailing zeros trimmed, never rounded); only the locale separators are
// applied. `dp` is for derived averages / echoes where a fixed number of decimals reads better.
const SEP = { space: ' ', comma: ',', dot: '.', none: '' };
const DECIMAL = /^[+-]?\d+(\.\d+)?$/;

const MAX_DISPLAY_DP = 6;   // display only: 166666.666666666667 shows as 166 666,666667; the API value stays exact
const trimZeros = (s) => (s.includes('.') ? s.replace(/0+$/, '').replace(/\.$/, '') : s);

export function numberText(value, { dp } = {}) {
  if (value == null || value === '') return null;
  let text = String(value).trim();
  if (!DECIMAL.test(text)) return null;
  if (dp != null) text = Number(text).toFixed(dp);
  else if ((text.split('.')[1] || '').length > MAX_DISPLAY_DP) text = Number(text).toFixed(MAX_DISPLAY_DP);
  const negative = text.startsWith('-');
  const [whole, decimals] = trimZeros(text.replace(/^[+-]/, '')).split('.');
  const f = getFormatting();
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, SEP[f.thousands_separator] ?? ' ');
  const out = grouped + (decimals ? (SEP[f.decimal_separator] ?? ',') + decimals : '');
  return negative && out !== '0' ? `\u2212${out}` : out;   // true minus, same glyph as the standing-% chips
}

// Text for an <input>: the stored dot-decimal in the user's decimal separator (typing converts back with replace(',', '.')).
export const decimalInput = (v) => (v == null ? '' : String(v).replace('.', SEP[getFormatting().decimal_separator] ?? '.'));

export const currencyLabel = () => getFormatting().currency_label ?? 'FCFA';

export const moneyText = (value, opts) => {
  const n = numberText(value, opts);
  return n == null ? null : `${n} ${currencyLabel()}`;
};

export const pctText = (value) => {
  const n = numberText(value);
  return n == null ? null : `${n} %`;
};

export const signedPctText = (value) => {
  const p = pctText(value);
  return p != null && Number(value) > 0 ? `+${p}` : p;
};

// Chip tone from the SIGN of a server-provided number (the client never computes money).
export const signTone = (value) => (Number(value) > 0 ? 'good' : Number(value) < 0 ? 'warn' : 'mut');

export const initials = (name) => String(name || '?').split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join('').toUpperCase();
